import React from 'react'
import styled from 'styled-components'

const StyledFormInput = styled.div`
  position: relative;
  margin-bottom: 12px;

  &:focus-within label {
    color: ${(props) => (props.error ? '#9f2121' : '#4c84ff')};
  }
`

const StyledTextareaTop = styled.div`
  display: flex;
  justify-content: space-between;

  margin-bottom: 8px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
  font-size: 11px;
`

const StyledLabel = styled.label`
  display: block;
  flex: 0;
  margin-bottom: 0;
  color: ${(props) => (props.error ? '#9f2121' : '#b0bac9')};
  letter-spacing: 1.12px;
  text-transform: uppercase;
  white-space: nowrap;

  transition: all 0.5s;
`

const StyledTextarea = styled.textarea`
  display: block;
  width: 100%;
  height: 240px;
  outline: none;
  padding: 10px 10px;

  border: 1px solid ${(props) => (props.error ? '#9f2121' : '#ececf0')};
  border-radius: 2px;

  color: #727272;
  transition: all 0.5s;

  ::placeholder {
    font-size: 14px;
    color: rgba(139, 147, 167, 0.6);
  }

  :focus {
    border: 1px solid ${(props) => (props.error ? '#9f2121' : '#4c84ff')};
  }
`

const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 22px;
  transform: translateY(-50%);
`

const StyledError = styled.div`
  color: #9f2121;
  opacity: 0;
  transition: all 0.5s;

  &.active {
    opacity: 1;
  }
`

export default ({
  input,
  label = null,
  type,
  renderIcon = null,
  meta: { touched = true, error } = {}
}) => {
  const showingError = touched && error

  return (
    <StyledFormInput error={showingError}>
      {label && (
        <StyledTextareaTop>
          <StyledLabel error={showingError} htmlFor={input.name}>
            {label}
          </StyledLabel>
          <StyledError className={showingError ? 'active' : ''}>
            {error}
          </StyledError>
        </StyledTextareaTop>
      )}

      <StyledTextarea
        {...input}
        multiple
        // rows={4}
        // cols="50"
        type={type}
        name={input.name}
        id={input.name}
        error={showingError}
      />
      {renderIcon && <IconWrapper>{renderIcon()}</IconWrapper>}
    </StyledFormInput>
  )
}
